import { render } from "./PDFNotaFiscal.vue?vue&type=template&id=2a265555&scoped=true"
import script from "./PDFNotaFiscal.vue?vue&type=script&lang=js"
export * from "./PDFNotaFiscal.vue?vue&type=script&lang=js"

import "./PDFNotaFiscal.vue?vue&type=style&index=0&id=2a265555&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a265555"]])

export default __exports__